const StorageService = {
  get(key) {
    return window.localStorage.getItem(key);
  },

  set(key, value) {
    return window.localStorage.setItem(key, value);
  }
};

const StorageKeys = {
  HAS_SEEN_APP_INTRO: "has-seen-app-intro",
  ENABLE_DARK_MODE: "enable-dark-mode" // currently in labs
};

export { StorageService, StorageKeys };
